import React, { useEffect, useState, useContext } from "react";
import schoolApi from "../../api/schoolApi";
import { Col, Row, Table } from "react-bootstrap";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import "jspdf-autotable";
import { SessionContext } from "../SessionProvider";


const DemandReports = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  const [allDemand, setAllDemand] = useState([]);

  useEffect(() => {
    if (selectedSessionId) {
      fetchAllFeesDetails();
    } else {
      setAllDemand([]);
    }
  }, [selectedSessionId]);

  const fetchAllFeesDetails = async () => {
    try {
        const result = await schoolApi.getAllFeesDemand(selectedSessionId);
        if (result.result) {
          setAllDemand(result.result);
        }
    } catch (error) {
      console.error("Error fetching fee data:", error);
    }
  };

  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };

  const formatData = (data) => {
    return {
      ...data,
      total_demands: formatNumberWithCommas(data.total_demands),
      defaulter: formatNumberWithCommas(data.defaulter),
      dropouts: formatNumberWithCommas(data.dropouts),
      concession: formatNumberWithCommas(data.concession),
      final_demand: formatNumberWithCommas(data.final_demand),
    };
  };

  const formattedData = allDemand.map(formatData);

  const header = [
    {
      title: "Total Demands",
      prop: "total_demands",
      isFilterable: true,
      show: true,
    },
    { title: "Defaulter", prop: "defaulter", isFilterable: true, show: true },
    { title: "Dropouts", prop: "dropouts", isFilterable: true, show: true },
    { title: "Concession", prop: "concession", isFilterable: true, show: true },
    {
      title: "Final Demand",
      prop: "final_demand",
      isFilterable: true,
      show: true,
    },
  ];

  return (
    <div>
      <Row className="g-0">
        <Col lg={12}>
          {formattedData.length > 0 ? (
            <DatatableWrapper
              body={formattedData}
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 15,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              <Table striped className="data-table">
                <TableHeader />
                <TableBody />
              </Table>
            </DatatableWrapper>
          ) : (
            <p>No record found</p>
          )}
        </Col>
        <Col lg={2}></Col>
      </Row>
    </div>
  );
};

export default DemandReports;
